import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessCapacityWorkEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-capacity-work-embed',
	exact: true,
	path: '/jira/core/projects/:projectKey/capacity/work/embed',
};
